/**
 * Densité de l'interface (« Normal » / « Condensé », ADR-092) : confort **par appareil**, gardé dans
 * le stockage du navigateur par ce seul module, sous une seule clé et deux valeurs fermées. La
 * préférence portée par le serveur (`SetInterfacePreference`) reste en file d'attente. Une garde de
 * test (`test/guards.test.ts`) le vérifie. Lecture et écriture sous try/catch.
 */

export type Density = 'normal' | 'compact';

export const DENSITY_KEY = 'ayumia.ui.density';
export const DENSITIES: readonly Density[] = ['normal', 'compact'];

export function readDensity(): Density {
  try {
    const stored = window.localStorage.getItem(DENSITY_KEY);
    return stored === 'compact' ? 'compact' : 'normal';
  } catch {
    return 'normal';
  }
}

export function writeDensity(density: Density): void {
  const value: Density = density === 'compact' ? 'compact' : 'normal';
  try {
    window.localStorage.setItem(DENSITY_KEY, value);
  } catch {
    // Stockage indisponible : la densité vaut pour la session de la page seulement.
  }
}
